import 'aem-libs-react-ts/src/configuration/publicPath'

import { bootstrap } from 'aem-libs-react-ts/src/inlet/bootstrap'

import { App } from './App'
import { APP_NAME } from './constants'
import './i18n'
import { initStore } from './store'
import type { EarlyRepaymentParams } from './types'

bootstrap<EarlyRepaymentParams>({
  appName: APP_NAME,
  AppComponent: App,
  options: {
    onFetchParams: initStore
  }
})
